import React, { useState } from 'react';
import {Button, Form, Modal, ConfigProvider, notification, Select, Row, Col, Input, Switch} from 'antd';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";
import {useNavigate} from "react-router-dom";
import {EditOutlined} from "@ant-design/icons";


const EditVersionDetails = ({ open, onCreate, onCancel , mode, id, appDomain, code, desc, deprecate, name, os, downloadsUrl, setVersionList}) => {
    const [form] = Form.useForm();
    const OsOptions = [{value: "android", label: "android"}, {value: "ios", label: "ios"}]
    const ModeOptions = [{value: "no_notification", label: "no_notification"}, {value: "force_update", label: "force_update"}, {value: "only_notification", label: "only_notification"}]
    return (
        <ConfigProvider direction="rtl">
            <Modal
                // style={{height: "600px"}}
                bodyStyle={{height: 420}}
                // style={{fontFamily: "iranSansBold"}}
                width={550}
                open={open}
                title="ویرایش ورژن"
                okText="تایید"
                cancelText="انصراف"
                onCancel={onCancel}
                closable={false}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreate(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >


                <Form
                    form={form}
                    layout="vertical"
                    name="form_in_modal"
                    initialValues={{
                        ["os"]: os,
                        ["name"]: name,
                        ["mode"]: mode,
                        ["appDomain"]: appDomain,
                        ["code"]: code,
                        ["deprecate"]: deprecate,
                        ["desc"]: desc,
                        ["downloadsUrl"]: downloadsUrl,
                            modifier: 'public',
                    }}
                >

                    <Row>
                        <Col xl={7} xs={7} xxl={7} ><Form.Item name="os" label={<p style={{fontFamily: "iranSansBold"}}>سیستم عامل</p>} requiredMark={"optional"}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'لطفا برای سیستم عامل مقداری را انتخاب کنید!',
                                            },
                                        ]}
                        >
                            <Select
                                style={{
                                    width: 130,
                                }}
                                options={OsOptions}/>
                        </Form.Item></Col>

                        <Col xl={9} xs={9} xxl={9} >
                            <Form.Item name="mode" label={<p style={{fontFamily: "iranSansBold"}}>مود</p>} requiredMark={"optional"}
                                                                  rules={[
                                                                      {
                                                                          required: true,
                                                                          message: 'لطفا برای مود مقداری را انتخاب کنید!',
                                                                      },
                                                                  ]}
                        >
                            <Select
                                // defaultValue="android"
                                style={{
                                    width: 150,
                                }}
                                options={ModeOptions}/>
                        </Form.Item></Col>

                        <Col xl={8} xs={8} xxl={8} >
                            <Form.Item name="name" label={<p style={{fontFamily: "iranSansBold"}}>نام</p>} requiredMark={"optional"}
                                                                  rules={[
                                                                      {
                                                                          required: true,
                                                                          message: 'لطفا برای نام مقداری وارد کنید!',
                                                                      },
                                                                  ]}>

                           <Input style={{borderRadius: "10px"}} />
                        </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={8} xs={8} xxl={8} >
                            <Form.Item name="appDomain" label={<p style={{fontFamily: "iranSansBold"}}>اپ دامین</p>} requiredMark={"optional"}
                                       style= {{width: "130px"}}
                                       rules={[
                                           {
                                               required: true,
                                               message: 'لطفا برای نام مقداری وارد کنید!',
                                           },
                                       ]}>

                                <Input style={{borderRadius: "10px"}} />
                            </Form.Item>


                        </Col>

                        <Col xl={8} xs={8} xxl={8} >
                            <Form.Item name="code" label={<p style={{fontFamily: "iranSansBold"}}>کد</p>} requiredMark={"optional"}
                                       style= {{width: "130px"}}
                                       rules={[
                                           {
                                               required: true,
                                               message: 'لطفا برای نام مقداری وارد کنید!',
                                           },
                                       ]}>

                                <Input style={{borderRadius: "10px"}} />
                            </Form.Item>


                        </Col>

                        <Col xl={8} xs={8} xxl={8} >
                            <Form.Item name="deprecate" label={<p style={{fontFamily: "iranSansBold"}}>منسوخ شده</p>} requiredMark={"optional"}
                                       style= {{width: "130px"}}
                                       rules={[
                                           {
                                               required: true,
                                               message: 'لطفا برای نام مقداری وارد کنید!',
                                           },
                                       ]}>
                                <Switch/>
                            </Form.Item>


                        </Col>
                    </Row>

                    <Row>
                        <Col xl={18} xxl={18} xs={18} >
                            <Form.Item name="downloadsUrl"  label={<p style={{fontFamily: "iranSansBold"}}>آدرس دانلود</p>}
                                        requiredMark={"optional"}
                                       rules={[
                                           {
                                               required: true,
                                               message: "آدرس دانلود الزامی است!"
                                           },
                                       ]}
                            >
                                <Input style={{textAlign: "center"}}/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={24} xxl={24} xs={24} >
                    <Form.Item name="desc"  label={<p style={{fontFamily: "iranSansBold"}}>توضیحات</p>}
                               // requiredMark={"optional"}

                               rules={[
                                   {
                                       required: false,
                                       message:'لطفا توضیحات را تکمیل کنید!' ,
                                   },
                               ]}
                    >
                        <Input.TextArea />
                    </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </Modal>
        </ConfigProvider>
    );
};

const EditModal = (props) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }
    const onCreate = async (values) => {

        const data = {
            desc: values.desc,
            code: values.code,
            name: values.name,
            mode: values.mode,
            os: values.os,
            appDomain: values.appDomain,
            deprecate: values.deprecate,
            downloadsUrl: values.downloadsUrl
        }

        // await console.log("data is", data);

        await Axios.put(`${Api}updateVersion/${props.id}`, data
        )
            .then(async (data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    await notification.open({
                        message: "موفقیت",
                        description: "درخواست با موفقیت انجام شد!",
                        style: {
                            background: "#43a047",
                            color: "white",
                            fontFamily: "IRANSansMobileFaNum",
                            borderRadius: "5px",
                        }
                    })

                }
                else {
                    RedNotification(data.message);
                }

            })
            .catch((error) => {
                // console.log(`err is ${error}`);
            });

        await Axios.get(`${Api}allVersion?page=${props.pageNumber}`
        )
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    props.setVersionList(data.data.data);

                }

            })
            .catch((error) => {
                // console.log(`err is ${error}`);
            });

        // // console.log('Received values of form: ', values);
        await setOpen(false);
    };
    return (
        <div >
            <Button
                type="primary"
                onClick={() => {
                    setOpen(true);
                }}
            >
                <EditOutlined  />

            </Button>

            <EditVersionDetails

                             open={open}
                             onCreate={onCreate}
                             onCancel={() => {
                                 setOpen(false);
                             }}

                             id={props.id} os={props.os} name={props.name} mode={props.mode}
                             appDomain={props.appDomain} code={props.code} deprecate={props.deprecate}
                             desc={props.desc} downloadsUrl={props.downloadsUrl}
            />
        </div>
    );
};
export default EditModal;